import React from 'react';
import { Link } from 'react-router-dom';

interface FooterProps {
  noBorder?: boolean;
  absolute?: boolean;
  fixedOnDesktop?: boolean;
}

const Footer: React.FC<FooterProps> = ({ noBorder = false, absolute = false, fixedOnDesktop = false }) => (
  <footer className={`bg-dark-900/90 backdrop-blur-lg ${noBorder ? '' : 'border-t border-white/10'} ${absolute ? 'fixed left-0 right-0 bottom-0 w-full z-40' : ''} ${fixedOnDesktop ? 'lg:fixed lg:left-0 lg:right-0 lg:bottom-0 lg:w-full lg:z-40' : ''}`}>
    <div className="w-full px-4 py-3 md:py-4 md:px-6 lg:px-8">
      <div className="flex flex-col items-center justify-between gap-3 md:gap-4 md:flex-row">
        <p className="text-xs text-center md:text-sm text-white/60 md:text-left">
          © 2025 Incupie™. All rights reserved.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4 lg:gap-6">
          {/* Social and Navigation Links as text, identical spacing */}
          <a
            href="https://discord.gg/7WsMfhweUs"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs transition-colors duration-300 md:text-sm text-white/60 hover:text-white/90"
          >
            Discord
          </a>
          <a
            href="https://github.com/incupie"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs transition-colors duration-300 md:text-sm text-white/60 hover:text-white/90"
          >
            GitHub
          </a>
          <a
            href="https://twitter.com/incupie"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs transition-colors duration-300 md:text-sm text-white/60 hover:text-white/90"
          >
            Twitter
          </a>
          <Link to="/privacy" className="text-xs transition-colors duration-300 md:text-sm text-white/60 hover:text-white/90">
            Privacy
          </Link>
          <Link to="/terms" className="text-xs transition-colors duration-300 md:text-sm text-white/60 hover:text-white/90">
            Terms
          </Link>
          <Link to="/contact" className="text-xs transition-colors duration-300 md:text-sm text-white/60 hover:text-white/90">
            Contact
          </Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
